// extracted by mini-css-extract-plugin
export default {"container":"Ro-z","ratingLayout":"So-z","ratingLabel":"To-z","nonInteractiveRatingLabel":"Uo-z"};